module.exports = __webpack_public_path__ + "img/chris (24).fb73299b.jpg";